import { render, staticRenderFns } from "./SetupMessageBird.vue?vue&type=template&id=9f574acc&"
import script from "./SetupMessageBird.vue?vue&type=script&lang=js&"
export * from "./SetupMessageBird.vue?vue&type=script&lang=js&"
import style0 from "./SetupMessageBird.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports